import create from "zustand";

export const useFormBuilderState = create<FormBuilderState>((set) => ({
  editModeStatus: false,
}));

interface FormBuilderState {
  editModeStatus: boolean;
}
